import React from 'react';
import { Close } from '@material-ui/icons';
import { Modal as ModalComponent } from '@material-ui/core';
import DragAndDrop from 'src/Components/Common/DragAndDrop';
import { Center, ModalContainer, ModalHeader, Title, CloseButton, Content, TicketInfo, DocumentsSection, SectionTitle, SectionDescription, Footer, CancelButton, ConfirmButton, } from './sharedModalStyles';
export var ModalLayout = function (_a) {
    var _b;
    var isOpen = _a.isOpen, onClose = _a.onClose, title = _a.title, ticket = _a.ticket, children = _a.children, confirmButtonLabel = _a.confirmButtonLabel, onConfirm = _a.onConfirm, _c = _a.isConfirmDisabled, isConfirmDisabled = _c === void 0 ? false : _c, _d = _a.isLoading, isLoading = _d === void 0 ? false : _d;
    var buildingName = ((_b = ticket.building) === null || _b === void 0 ? void 0 : _b.name) || '';
    var serviceName = ticket.provider_service || '';
    return (React.createElement(ModalComponent, { open: isOpen, onClose: onClose },
        React.createElement(Center, null,
            React.createElement(ModalContainer, null,
                React.createElement(ModalHeader, null,
                    React.createElement(Title, null, title),
                    React.createElement(CloseButton, { onClick: onClose },
                        React.createElement(Close, null))),
                React.createElement(Content, null,
                    React.createElement(TicketInfo, null,
                        "Ticket #",
                        ticket.ticket_number,
                        buildingName && " | Edificio " + buildingName,
                        serviceName && " | Servicio: " + serviceName),
                    children),
                React.createElement(Footer, null,
                    React.createElement(CancelButton, { onClick: onClose }, "Cancelar"),
                    React.createElement(ConfirmButton, { onClick: onConfirm, disabled: isConfirmDisabled || isLoading }, confirmButtonLabel))))));
};
export var DocumentsSectionComponent = function (_a) {
    var files = _a.files, onFilesSelected = _a.onFilesSelected, onRemoveFile = _a.onRemoveFile;
    return (React.createElement(DocumentsSection, null,
        React.createElement(SectionTitle, null, "Documentos adjuntos"),
        React.createElement(SectionDescription, null, "Opcional. Adjunta fotos o documentos para respaldar la solicitud (PDF o JPG)."),
        React.createElement(DragAndDrop, { onFilesSelected: onFilesSelected, files: files, onRemoveFile: onRemoveFile })));
};
